import { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Terms() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="terms-page" className="pt-20">
      <section className="pt-[35px] pb-[35px] md:py-16 bg-[#FBFBF7] border-b border-border">
        <div className="mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6">
              &larr; Back to Home
            </Link>
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Terms of Use</h1>
          </motion.div>
        </div>
      </section>

      <section className="pt-[35px] pb-[35px] md:py-16">
        <div className="mx-auto w-full max-w-3xl px-4 sm:px-6">
          <div className="prose prose-sm max-w-none space-y-8">
            <div>
              <h2 className="text-xl font-bold mb-3">1. Acceptance of Terms</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                By accessing and using the Maple Code Academy website (maplecodeacademy.ca), you accept and agree to be bound by the terms and conditions outlined in this agreement. If you do not agree to these terms, please do not use our website or services.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">2. Services</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Maple Code Academy provides coding, robotics, and digital creativity education programs for children. Our services include online classes, workshops, and camps. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">3. Registration and Enrollment</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Parents or guardians must complete the registration process for their children. You agree to provide accurate, current, and complete information during registration. Enrollment is subject to availability and age requirements for specific programs.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">4. Payment and Refunds</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Program fees are due at the time of enrollment. We offer a full refund within the first two weeks of enrollment. After this period, refunds will be prorated based on the remaining sessions. All refund requests must be submitted in writing.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">5. Intellectual Property</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                All content on this website, including text, graphics, logos, and images, is the property of Maple Code Academy and is protected by copyright laws. Students retain ownership of their creative projects made during our programs.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">6. Limitation of Liability</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Maple Code Academy shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services or website. Our total liability shall not exceed the amount paid for the specific program in question.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">7. Governing Law</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                These terms shall be governed by and construed in accordance with the laws of Canada. Any disputes shall be resolved in the appropriate courts of Canada.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">8. Contact</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                For questions about these Terms of Use, contact us at info@maplecodeacademy.ca.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
